import type { VersionedWording } from '@/lib/versioned-labels';
import { MODEL_SETTINGS_NAME } from '@matter_extractor/shared';

/**
 * How the versioned layer names « Les modèles » (vitrine.md section 5, issue
 * #192), everywhere it has to.
 *
 * A SINGLETON, like the texts of the noyaux (`noyau-texts-wording.tsx`): no
 * list, no card, no creation box, no retirement, no rename. So half of
 * `VersionedWording` names gestures this object never offers - the `settings`
 * logement renders neither the retirement panel nor its box - and those
 * sentences are written anyway, in French and true, because a wording that lied
 * in an unreachable corner would be the first thing a later lot copies.
 *
 * The prefixes are `modeles`: every mark of the head is `modeles-...`
 * (`modeles-entete`, `modeles-enregistrer`, `modeles-historique-ouvrir`), which
 * is what `reglages-modeles.spec.ts` and `screenshots-reglages-versionnes.mjs`
 * read, beside the panel's own `modeles-sieges` and `modeles-budget`.
 * Unaccented, so a spec can type them.
 */
export const MODEL_SETTINGS_WORDING: VersionedWording = {
  kind: 'models',
  entity: 'modeles',
  list: 'modeles',
  noun: ['réglage des modèles', 'réglages des modèles'],
  newTitle: MODEL_SETTINGS_NAME,
  createLabel: 'Écrire les modèles',
  saveHintNew: 'Crée la v1.',
  // The singleton is born at boot: no server draft is ever missing.
  draftStateNew: 'Aucune version encore.',
  // No referent plays the models: a SESSION freezes the version it starts on,
  // so the promise is about the sessions to come and not about a list.
  developmentHint: (nextNumber) =>
    `Les sessions neuves joueront la v${nextNumber} ; les sessions en cours gardent la version qu’elles ont figée.`,
  subject: (name) => name,
  retirement: {
    panelTitle: 'Les modèles ne se retirent pas',
    retiredTitle: 'Modèles retirés',
    confirmLabel: 'Retirer les modèles',
    panelHint: () => <>Un seul objet pour les cinq sièges et le plafond par étape, sans retrait.</>,
    retiredHint: (_name, day) => <>Retirés le {day}.</>,
    warningTitle: () => 'Aucune session ne pourrait plus démarrer',
  },
  refusal: {
    nameTaken: 'Les modèles portent un nom fixe.',
    nameTakenBy: () => 'Les modèles portent un nom fixe.',
    retired: 'Les modèles sont retirés.',
  },
};
